// Como a tela descreve uma alteração nas campanhas: o valor de cada item (situação ou
// orçamento) e a frase do que mudou. O orçamento vem em centavos da moeda da conta, como o
// Meta guarda — a maioria das moedas tem 2 casas; estas não têm nenhuma.
export type Nivel = 'campanha' | 'conjunto' | 'anuncio'
export type Tipo = 'pausar' | 'reativar' | 'orcamento'
export type ItemAlteracao = {
  nivel: Nivel
  id_externo: string
  nome: string
  campo: 'status' | 'orcamento_diario'
  antes: string | number
  depois: string | number
  aplicado?: boolean
}

const SEM_CENTAVOS = new Set(['CLP', 'COP', 'CRC', 'HUF', 'ISK', 'IDR', 'JPY', 'KRW', 'PYG', 'TWD', 'VND'])
const SITUACAO: Record<string, string> = { ACTIVE: 'Ativo', PAUSED: 'Pausado', ARCHIVED: 'Arquivado', DELETED: 'Apagado', REMOVED: 'Removido' }

export const NOME_NIVEL: Record<Nivel, string> = { campanha: 'Campanha', conjunto: 'Conjunto', anuncio: 'Anúncio' }

/** Plataformas em que o sistema aplica alterações, e o nome curto delas nos botões. */
export const PLATAFORMAS_ALTERAVEIS: Record<string, string> = { meta_ads: 'Meta', google_ads: 'Google Ads' }

/** "Conjunto" no Meta é "Grupo de anúncios" no Google. */
export const nomeNivel = (nivel: Nivel, plataforma: string) => (nivel === 'conjunto' && plataforma === 'google_ads' ? 'Grupo de anúncios' : NOME_NIVEL[nivel])

export function formatarOrcamento(centavos: number, moeda: string | null): string {
  const m = (moeda || 'BRL').toUpperCase()
  const valor = SEM_CENTAVOS.has(m) ? centavos : centavos / 100
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: m }).format(valor) + '/dia'
  } catch {
    return `${valor.toLocaleString('pt-BR')} ${m}/dia`
  }
}

export function formatarValor(i: Pick<ItemAlteracao, 'campo'>, v: string | number, moeda: string | null): string {
  return i.campo === 'status' ? (SITUACAO[String(v)] ?? String(v).toLowerCase()) : formatarOrcamento(Number(v), moeda)
}

/** "Pausar", "Reativar", "Aumentar o orçamento em 20%"... */
export function descreverTipo(tipo: Tipo, percentual: number | null): string {
  if (tipo === 'pausar') return 'Pausar'
  if (tipo === 'reativar') return 'Reativar'
  const p = Math.abs(percentual ?? 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })
  return `${(percentual ?? 0) > 0 ? 'Aumentar' : 'Reduzir'} o orçamento em ${p}%`
}

/** Ações do motor/IA que viram um botão "Aplicar" — revisar e manter não mudam nada. */
export function acaoDaSugestao(acao: string): { tipo: Tipo; percentual: number | null } | null {
  if (acao === 'pausar') return { tipo: 'pausar', percentual: null }
  if (acao === 'aumentar') return { tipo: 'orcamento', percentual: 20 }
  if (acao === 'reduzir') return { tipo: 'orcamento', percentual: -20 }
  return null
}
